import { Extension } from "@tiptap/core";

/**
 * Google-Docs / Word style list exit.
 *
 * In a bullet or numbered list, pressing Enter on a NON-empty item splits it
 * into a new item (StarterKit's default). But pressing Enter on an EMPTY item
 * should NOT leave a blank bullet behind — it should remove the empty item and
 * drop the cursor back into a normal paragraph (exiting / outdenting the list).
 *
 * StarterKit binds Enter on `listItem` to `splitListItem`, which on an empty
 * top-level item just creates another empty bullet. We run first (high
 * priority): when the cursor sits in an empty list item we `liftListItem`
 * (exit one level) and stop; otherwise we defer to the default split.
 */
export const ListExitOnEnter = Extension.create({
  name: "listExitOnEnter",
  priority: 1000,

  addKeyboardShortcuts() {
    return {
      Enter: () => {
        const { editor } = this;
        if (!editor.isActive("listItem")) return false;

        const { selection } = editor.state;
        if (!selection.empty) return false;

        // Only fire when the current text block (the list item's paragraph)
        // has no content — i.e. the user is on a fresh, empty bullet.
        if (selection.$from.parent.content.size > 0) return false;

        // Lift the empty item out of the list. Returns false if it can't
        // (then the default split runs), so this is always safe.
        return editor.commands.liftListItem("listItem");
      },
    };
  },
});
